import { lazy, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props as TwilioActivityStatusIndicatorProps } from './TwilioActivityStatusIndicator.tsx';

export const AsyncTwilioActivityStatusIndicator: LazyComponent<
	({ agentFragment }: TwilioActivityStatusIndicatorProps) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazy(
		() =>
			import(
				/* webpackChunkName: "async-twilio-activity-status-indicator" */ './TwilioActivityStatusIndicator.tsx'
			).then(({ TwilioActivityStatusIndicator }) => TwilioActivityStatusIndicator),
		{ ssr: false },
	);
